"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedInButton = void 0;
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
exports.LinkedInButton = (0, styled_components_1.default)(antd_1.Button) `
	background: ${({ theme }) => theme.color.linkedin};
	color: ${({ theme }) => theme.color.white};
	justify-content: flex-start;
	text-align: center;
	border-radius: 32px;
	color: white;
	margin-bottom: 0.5rem;
	border: none;
	padding: 0.5rem;

	&&:hover {
		background: ${({ theme }) => theme.color.linkedin};
		color: ${({ theme }) => theme.color.white};
	}
`;
